Wrapper for image sources in storyblok which can be either of url type or of
asset type, image sources are passed as props. Whichever valid format comes
first will be used

<template>
  <img v-if="src" :src="src" alt="" :loading="lazy ? 'lazy' : 'eager'" />
</template>

<script setup>
import { computed } from 'vue'
import { getImgSrc, getValidImageSrc } from '../utils/imgUtils'

const props = defineProps({
  imgSources: {
    type: Array,
    required: true,
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  lazy: {
    type: Boolean,
    default: true,
  },
})

const imgUrl = computed(() => {
  return getValidImageSrc(props.imgSources)
})
const src = computed(() => {
  return getImgSrc({
    imgUrl: imgUrl.value,
    width: props.width,
    height: props.height,
  })
})
</script>
